import { render, staticRenderFns } from "./mynav.vue?vue&type=template&id=5fa31294&scoped=true"
import script from "./mynav.vue?vue&type=script&lang=js"
export * from "./mynav.vue?vue&type=script&lang=js"
import style0 from "./mynav.vue?vue&type=style&index=0&id=5fa31294&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa31294",
  null
  
)

export default component.exports